<template>
	<div class="page" :style="[pageStyle]">
		<Tip :title="title" />
		<div class="from_div">
			<div class="screen_div">
				<el-input class="input" v-model="screen.good_name" placeholder="商品名称" clearable/>
				<el-button type="primary">筛选</el-button>
			</div>
			<el-table ref="multipleTable" class="table_div"
				:data="tableData"
				:header-cell-style="tabStyle" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50" align="center"/>
				<el-table-column label="商品id" prop="good_id" align="center"/>
				<el-table-column label="供货" prop="good_source_text" align="center"/>
				<el-table-column label="商品名称" prop="good_name" align="center"/>
				<el-table-column label="规格id" prop="sku_id" align="center"/>
				<el-table-column label="规格名称" prop="spec_data_str" align="center"/>
				<el-table-column label="库存" prop="stock" align="center"/>
				<el-table-column label="成本价" prop="cost_price" align="center"/>
				<el-table-column label="销售价" prop="sale_price" align="center"/>
			</el-table>
		</div>
		<div class="foot_div">
			<div class="btn_div">
				<el-button @click="close">返回</el-button>
				<el-button type="primary" @click="subMit">确定</el-button>
			</div>
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../Tip/Tip.vue"
	import {goodLists} from "../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props:{
			type:{
				type:Number
			}
		},
		data() {
			return {
				title: '关联商品',
				screen: {
                    state: 1,
					good_name: '', //商品名称
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
				total: 10,
				tableData: [],
				multipleSelection:[]
			}
		},
		computed: {
			pageStyle(){
				return {
					position: this.type == 0 ? 'relative' : ''
				}
			},
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getGoodList();
		},
		methods: {
			//获取商品列表
			getGoodList() {
				goodLists({
					...this.screen
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						res.data.forEach(i => {
							i.skus.forEach(j => {
								j.good_id = i.good_id
								j.good_source_text = i.good_source_text
								j.good_name = i.good_name
							})
							this.tableData.push(...i.skus)
						})
						// this.getRowSpan(this.tableData);
					}
				}).catch(err => {})
			},
			
			handleSelectionChange(val) {
				this.multipleSelection = val.map(obj => obj);
			},
			
			//提交关联的商品数据
			subMit(){
				if(this.multipleSelection.length > 0){
					this.$emit('goodList',this.multipleSelection)
				}else{
					this.$message.error('请选择需要关联的商品');
				}
			},
			
			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.tableData = []
				this.getGoodList();
			},
			
			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: absolute;
		left: 0px;
		top: 0;
		padding: 20px 20px 0 20px;
	}
	
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-bottom: 20px;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
		overflow-y: scroll;
		height: 627px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		display: flex;
		justify-content: space-between;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}
	
	.btn_div {
		display: flex;
		margin-top: 15px;
		height: 40px;
	}
	
	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}
	
	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}
	
	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>